module.exports = __webpack_public_path__ + "img/Mercury-min.4d576c5b.png";